"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Icon = _styledComponents["default"].div.withConfig({
  displayName: "icon__Icon",
  componentId: "sc-1uum3in-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-block;\n    font-family: 'icomoon';\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    text-decoration: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: ", ";\n    color: ", ";\n    &::before {\n        content: ", ";\n    }\n"])), function (props) {
  return props.fontSize ? props.fontSize : 'inherit';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return "\"".concat(props.content, "\"");
});

var _default = Icon;
exports["default"] = _default;